import { CheckCircleOutlineIcon } from '@assets/icons/CheckCircleOutlineIcon';
import { SettingsIcon } from '@assets/icons/minor';
import { useNotificationsCenter } from '@contexts/NotificationsCenterContext';
import { Tabs } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Amplitude } from 'src/amplitude';

function NotificationsCenterHeader() {
  const { t } = useTranslation();

  const {
    tabFilter: filter,
    setTabFilter: setFilter,
    markAllAsRead,
    setPopoverVisible,
  } = useNotificationsCenter();
  const [_, setParams] = useSearchParams();

  const openSettingsModal = useCallback(() => {
    Amplitude.trackNotificationsOpenSettings();
    setPopoverVisible(false);
    setParams({ subscriptionsSettings: 'pick-report' });
  }, [setPopoverVisible, setParams]);

  const onMarkAllAsRead = useCallback(() => {
    Amplitude.trackNotificationsMarkAllAsRead();
    markAllAsRead();
  }, [markAllAsRead]);

  const onChangeTab = useCallback(
    (key: string) => {
      const tab = key as 'all' | 'unread';
      Amplitude.trackNotificationsChangeTab(tab);
      setFilter(tab);
    },
    [setFilter]
  );

  return (
    <div className="flex flex-col p-4 pb-0">
      <div className="flex justify-between  items-center mb-2">
        <span className="font-sans font-bold text-[22px] leading-[28px]">
          {t('notification.title')}
        </span>
        <div className="flex items-center justify-center gap-4">
          <button type="button" className="flex items-center gap-1" onClick={onMarkAllAsRead}>
            <CheckCircleOutlineIcon className="inline-block w-5 h-5 text-sy-green-60" />
            <span className="text-sy-green-60 font-semibold">
              {t('notifications.mark_all_read')}
            </span>
          </button>
          <button
            type="button"
            data-testid={'notifications-header-settings'}
            onClick={openSettingsModal}
          >
            <SettingsIcon width={24} height={24} />
          </button>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <Tabs
          activeKey={filter}
          onChange={onChangeTab}
          className="[&_.ant-tabs-tab-active_.ant-tabs-tab-btn]:text-sy-green-60 [&_.ant-tabs-ink-bar]:bg-sy-green-60 [&_.ant-tabs-tab-btn:hover]:!text-sy-green-60 [&_.ant-tabs-tab]:m-0"
        >
          <Tabs.TabPane tab={<p className="px-4">{t('notifications.filter.all')}</p>} key="all" />
          <Tabs.TabPane
            tab={<p className="px-4">{t('notifications.filter.unread')}</p>}
            key="unread"
          />
        </Tabs>
      </div>
    </div>
  );
}

export { NotificationsCenterHeader };
